module.exports = __webpack_public_path__ + "img/music_002.b79b32eb.png";